import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ActivityServiceService } from 'src/app/services/activity-service.service';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';

@Component({
  selector: 'app-manage-action',
  templateUrl: './manage-action.component.html',
  styleUrls: ['./manage-action.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageActionComponent implements OnInit {
  sessionDataString:any;
  form:FormGroup;
  data = [];
  dataSource = new MatTableDataSource(this.data);
  filterOpen: boolean = false

  displayedColumns: string[] = [
    "ActivityNo",
    "ApplicationNo",
    "ActivityType",
    "TargetDate",
    "PersonResponsible",
    "Comments",
    "status",
  ];
  filtershow=false;
  dataExcel: any = [];
  excelColumns: string[];
  filteredList:any;
  userList:any;
  activitynumber:any;
  filteredList1:any;
  status:any

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private sessionService: UserSessionService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private navigationService: NavigationService,
    private activityService:ActivityServiceService,
    private LookupDataService:LookupDataServiceService,
    private formBuilder:FormBuilder
  ) { 
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)

    );
    console.log(this.sessionDataString)
  }

  ngOnInit(): void {
    
    this.form=this.formBuilder.group({
      personResponsible_Id:[],
      activityNumber:[],
      actionStatus:[]
    })
    this.getTableData(null)
    this.getuser()
    this.getActivityNumber()
    this.getstatus()
  }
  getTableData(data){

    this.activityService.getManageActionList(data).subscribe((result:any) => {
      console.log('data',result)
      
      this.data = result.map(item => {
        switch(item.status) {
          case 1:
            item.status = 'New';
            break;
          case 2:
            item.status = 'In Process';
            break;
          case 3:
            item.status = 'Closed';
            break;
        }
        return item;
      });
      
      this.dataExcel = this.data;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
    });
  }

  getuser(){
    this.LookupDataService.getInternalUsers(true).subscribe((result)=>{
      console.log('user',result)
      this.userList=result

      this.filteredList=[...this.userList];
    })
  }
  getActivityNumber(){
    this.LookupDataService.getActivityNumber(this.sessionDataString.id).subscribe((result)=>{
      this.activitynumber=result

      this.filteredList1=[...this.activitynumber];
    })
  }
  getstatus(){
    this.status=[
      {key:'1', value:'New'},
      {key:'2', value:'In Progress'},
      {key:'3', value:'Closed'},
  

    ]
    
  }

  onSelectChange(event){
    const selectedName = event.value;

    if (selectedName === 'user') {
      this.form.get('personResponsible_Id').setValue(null);
      this.filteredList = [...this.userList];  
    }
    if (selectedName === 'Activityno') {
      this.form.get('activityNumber').setValue(null);
      this.filteredList = [...this.userList];  
    }
    if (selectedName === 'status') {
      this.form.get('actionStatus').setValue(null);
      this.filteredList = [...this.userList];  
    }
  }
    exportAsXLSX(): void {
      this.loaderService.start();
      setTimeout(() => {
        var exportData = this.dataExcel;
        if (!exportData || exportData.length === 0) {
          this.toastr.showInfo("No data available to export");
          this.loaderService.hide();
          return;
        }
        const excelList = [];
        this.excelColumns = [
          "S.No",
          "Activity Number",
          "Application Number",
          "Activity Type",
          "Target Date",
          "Person Responsible",
          "Comments",
          "Status"
        ];
        exportData.forEach((a, index) => {
          excelList.push({
            sno: ++index,
            "Activity Number":a.activityNo,
            "Application Number":a.applicationNumber,
            "Activity Type":a.activityType,
            "Target Date":a.targetDate,
            "Person Responsible":a.personResponsible,
            "Comments":a.comments,
            "Status":a.status,


          });
        });
        this.excelService.exportAsExcelFile(excelList, "ManageAction_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
        this.loaderService.stop();
      }, 500);
    }

    clearFilter(){
      this.getTableData(null)
      this.form.reset()
    }

    filterToogle(){
      this.filtershow=this.filtershow?false:true;
    }
    filter(){
      let data=this.getNonNullValues();
      console.log(data);
      this.getTableData(data);
    }

    getNonNullValues(): { [key: string]: any } {
      const rawValues = this.form.value;
      const filteredValues = Object.fromEntries(
        Object.entries(rawValues).filter(([key, value]) => value !== null && value !== undefined)
      );
      return filteredValues;
    }
    view(data){
      this.navigationService.gotomanageactiondetails(data);
    }
}
